import { Component, OnInit, ViewChild, TemplateRef, ElementRef } from '@angular/core';
import { TableComponent } from 'src/app/shared/common-components/table/table.component';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AdminService } from '../admin.service';
import * as moment from 'moment';
import { MatSnackBar } from '@angular/material/snack-bar';
import { vovSharedService } from 'src/app/shared/services/vov-shared.service';




@Component({
  selector: 'app-user-roles',
  templateUrl: './user-roles.component.html',
  styleUrls: ['./user-roles.component.scss']
})
export class UserRolesComponent implements OnInit {
  showPassword = false;

  @ViewChild('formRef') formRef: TemplateRef<any>;
  @ViewChild('confirmRef') confirmRef: TemplateRef<any>;
  @ViewChild('passwordField') passwordField: ElementRef;

  @ViewChild(TableComponent, { static: false }) tableComp: TableComponent;
  public formDialog: MatDialogRef<any> = null;
  public confirmDialog: MatDialogRef<any> = null;
  public tableData;
  public showSpinner: boolean = false;
  public roles = [];
  public columnNames = {
    userName: 'User Name',
    email: 'Email',
    role: 'Role',
    actions: '',
  };
  selectedItem;
  userForm: FormGroup;
  password;
  btndisabled: boolean = false;
  public isReadonly: boolean = false;

  constructor(public dialog: MatDialog,
    private formBuilder: FormBuilder,
    private adminService: AdminService,
    public snackBar: MatSnackBar,
    private vovSharedService: vovSharedService
  ) { }

  ngOnInit(): void {
    this.userForm = this.formBuilder.group({
      userName: ['', [Validators.required, this.vovSharedService.customFieldValidator]],
      password: ['', [Validators.required, Validators.minLength(6)]],
      email: ['', Validators.required],
      role: ['', [Validators.required]],
    });
    this.vovSharedService.fetchAllRoles().subscribe((res) => {
      this.roles = res.rolesData.filter(role => role.id != 5 && role.id != 3);
      console.log(this.roles, 'roles')
      // this.streets.sort((a, b) => a.street.localeCompare(b.street));
    });
    this.getUsers();
  }

  getUsers() {
    this.showSpinner = true;
    this.adminService.fetchAllUserRoles().subscribe(res => {
      this.showSpinner = false;
      if (res.users_data.length > 0) {
        let users = [];
        res.users_data.sort((a, b) => <any>new Date(b.updatedAt).getTime() - <any>new Date(a.updatedAt).getTime());
        res.users_data.map((data: any) => {
          if (data.userRoles.length) {
            let user = {
              id: data.userRoles.map(i => i.id).join(),
              // date: moment(data.createdAt).format("MM/DD/YY"),
              userName: (data.userName) ? data.userName : null,
              email: (data.email) ? data.email : null,
              role: data.userRoles.length ? data.userRoles.map(r => r.role.name).join() : '',
              roleId: data.userRoles.length ? data.userRoles.map(r => r.role.id).join() : ''
            }
            users.push(user)
          }
        })
        console.log(users, 'user')
        this.tableData = users
      }
      this.tableRendering();
    })
  }

  openDialogForm() {
    (this.selectedItem == "" || this.selectedItem == undefined) ? this.isReadonly = false : this.isReadonly = true;
    console.log(this.selectedItem, 'submitt')
    this.btndisabled = false;
    this.formDialog = this.dialog.open(this.formRef, {
      width: '350px',
      data: 'data'
    });
    this.formDialog.afterClosed().subscribe(result => {
      this.isReadonly = false;
      this.selectedItem = '';
      this.userForm.reset();
    })
  }

  onAddressSubmit() {
    console.log(this.userForm.value, 'valll')
    this.btndisabled = true;
    this.adminService.createUserWithRoles(this.userForm.value).subscribe((res) => {
      this.formDialog.close();
      if (res.message == 'Already exists') {
        this.snackBar.open('Warning :' + 'User with role already exists.', '', {
          duration: 3000,
          horizontalPosition: 'right',
          panelClass: 'warning-snackbar'
        });
      } else if (res.message == 'User Role added Successfully') {
        this.snackBar.open('User with role added Successfully', '', {
          duration: 3000,
          horizontalPosition: 'right',
          panelClass: 'success-snackbar'
        });
      }
      this.getUsers();
      this.userForm.reset();

    });
  }

  selectedItems(item) {
    this.selectedItem = item.data;
    let id
    this.roles.map(r => {
      if (r.role === item.data.role) {
        id = r.id
      }
    });
    if (item.action === 'edit') {
      this.userForm.patchValue({
        userName: item.data.userName,
        email: item.data.email,
        role: item.data.roleId.split(',').map(res => +res)
      });
      this.userForm.controls["password"].clearValidators();
      this.userForm.controls["password"].updateValueAndValidity();
      this.openDialogForm();

    } else {
      this.confirmDialog = this.dialog.open(this.confirmRef, {
        width: '350px',
        data: 'data'
      });
    }
  }

  togglePassword() {
    this.showPassword = !this.showPassword;
    if (this.showPassword) {
      this.passwordField.nativeElement.setAttribute('type', 'text');
    } else {
      this.passwordField.nativeElement.setAttribute('type', 'password');
    }
  }




  confirmDelete(e) {
    this.deleteAddress(this.selectedItem.id);
    //e.preventDefault();
    this.confirmDialog.close();
    this.selectedItem = '';
    this.showSpinner = true;



  }

  onNoClick() {
    this.confirmDialog.close();
  }

  editAddress(e) {
    e.preventDefault();
    this.btndisabled = true;
    this.showSpinner = true;
    this.adminService.updateUserWithRoles({ data: this.userForm.value, id: this.selectedItem.id }).subscribe((res) => {
      this.showSpinner = false;
      if (res.message == 'Already exists') {
        console.log('hereee')
        this.snackBar.open('Warning :' + 'User with role already exists.', '', {
          duration: 3000,
          horizontalPosition: 'right',
          panelClass: 'warning-snackbar'
        });
      } else if (res.user == 'User Updated Successfully') {
        console.log('hereee')
        this.snackBar.open('User with role updated successfully.', '', {
          duration: 3000,
          horizontalPosition: 'right',
          panelClass: 'success-snackbar'
        });
      }
      this.getUsers();
      this.formDialog.close();
      this.userForm.reset();
      this.selectedItem = '';
    })
  }

  deleteAddress(user) {
    this.adminService.deleteRoleDetail(user).subscribe((res) => {
      this.snackBar.open('Success :' + res.user, '', {
        duration: 3000,
        horizontalPosition: 'right',
        panelClass: 'success-snackbar'
      });
      this.getUsers();
      this.tableRendering();

    });
  }

  tableRendering() {
    if (this.tableComp != undefined) {
      this.tableComp.renderTable();
    }
  }
}
